// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Icon from 'components/Icon';
import { sendEvent, sendPageview } from 'lib/analytics';

// local
import styles from './Header.pcss';
import Menu from './Menu';

export default class Header extends PureComponent {
  
  static propTypes = {
    className: PropTypes.string,
    links: Menu.propTypes.links,
    menuActive: PropTypes.bool,
    // bool -> *
    onToggleMenu: PropTypes.func,
  }
  static defaultProps = {
    links: [],
    menuActive: false,
    onToggleMenu: () => {},
  }
  
  handleMenuIconClick = () => this.props.onToggleMenu()
  
  handleLinkClick = ({ to, name }) => {
    const { onToggleMenu } = this.props;
    sendPageview(to);
    sendEvent('nav', name);
    onToggleMenu(false);
  }
  
  render() {
    const { className, menuActive, links } = this.props;
    
    const menuClassnames = classnames(styles.menu, className, {
      [styles.hide]: !menuActive,
    });

    return (
      <div className={ styles.header }>
        <div className={ styles.headerContent }>
          <div className={ styles.name }>{ 'Casey Seideman M.D.' }</div>
          <div className={ styles.subTitle }>
            <div className={ styles.jobTitle }>{ 'Pediatric Urologist' }</div>
            <div className={ styles.company }>{ 'OHSU - Portland, OR' }</div>
          </div>
        </div>
        <Menu
          className={ menuClassnames }
          onLinkClick={ this.handleLinkClick }
          links={ links } />
        <Icon
          className={ styles.menuIcon }
          type={ (menuActive ? 'close' : 'menu') }
          onClick={ this.handleMenuIconClick } />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx